import { render } from "./UnsubmittedPrs.vue?vue&type=template&id=08b75642"
import script from "./UnsubmittedPrs.vue?vue&type=script&lang=js"
export * from "./UnsubmittedPrs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__